module.exports = __webpack_public_path__ + "img/developer.05d1c63e.svg";